var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 176V16H496V176H16Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 336V176H496V336H16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496V336H496V496H16Z",
    fill: "#3498DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.578 270.166L254.916 258.943L240.654 270.965L247.415 255.455L231.574 245.605L248.415 247.243L252.887 229.134L256.533 245.656L275.138 244.313L260.551 252.887L267.578 270.166Z",
    fill: "#3498DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.84 239.008L153.673 227.279L139.916 239.807L147.002 223.66L130.836 214.447L148.382 216.197L152.149 197.975L155.907 215.204L174.4 213.155L159.177 222.053L166.84 239.008Z",
    fill: "#3498DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.202 312.998L155.035 301.27L141.277 313.797L148.363 297.65L132.198 288.437L149.744 290.187L153.51 271.966L157.269 289.194L175.762 287.145L160.538 296.043L168.202 312.998Z",
    fill: "#3498DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.242 239.235L359.075 227.506L345.318 240.034L352.404 223.887L336.238 214.674L353.784 216.423L357.551 198.202L361.309 215.43L379.802 213.381L364.579 222.28L372.242 239.235Z",
    fill: "#3498DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M373.604 313.225L359.932 303.011L346.68 314.024L352.168 297.865L337.6 288.664L354.664 288.891L358.913 272.192L363.97 288.491L381.164 287.372L367.226 297.218L373.604 313.225Z",
    fill: "#3498DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/HN.02d94ccc7e693843a089bc5dc51a162c.svg";
export { ForwardRef as ReactComponent };